import React, { memo, ReactElement } from 'react'

import { root, title as titleStyles, separator } from './Section.module.scss'
import Separator from '~components/Separator';

type Params = {
  title: string;
  footerTitle?: string;
  footerLink?: string;
  children?: ReactElement | ReactElement[] | boolean | boolean[];
  className?: string;
}

function Section({ title, footerTitle, footerLink, children, className }: Params) {
  return (
    <div className={`${root} ${className}`}>
      {title && <h2 className={titleStyles}>{title}</h2>}
      {children}
      {footerTitle && <Separator title={footerTitle} url={footerLink} hasArrow />}
    </div>
  )
}

export default memo(Section)
